import http from './http';

export function fetchFeedback() {
  return http.get('/feedback');
}

export function fetchUnreadFeedbackCount() {
  return http.get('/feedback/unread-count');
}

export function markFeedbackRepliesRead() {
  return http.put('/feedback/read');
}

export function markFeedbackReplyRead(id) {
  return http.put(`/feedback/${id}/read`);
}

export function submitFeedback(content) {
  return http.post('/feedback', { content });
}
